<template>
 <div class="backdrop" @click.self="closeModal">

    <div id="columnModalContent">
        <div id="heading">
            <div class="block" style="text-align:right;margin-bottom: 0;" @click="closeModal">
                Close
                <b-icon
                icon="close"
                size="is-small">
            </b-icon>
            </div>
            <h1>Upload Seal or Stamp</h1>
        </div>
        <div id="body">

<!--          TODO :: implement functionality to capture the images -->
            <template>
              <div id="signInModalBodyTopic">
                  <p>Note: Your personal/company seal can be <br/> placed under your signature.</p>
              </div>

                <div class="columns" style="overflow-y: scroll;position: relative; height: 300px;">
                    <div class="column" style="text-align:left;">
                        <div class="sealImageArea">

                          <!--<div id="sealImage"></div>-->
                          <!--<b-button type="is-primary" outlined rounded >Upload</b-button>-->
                            <UploadNICModal  @on-nic-captured="onSealCaptured" :crop_ratio=14/9 file_name="sealImage" :selectedImageURL="$root.customerData.sealImageURL" style="width: 100%; margin: auto;" />
                            <b-field
                                    :type="fieldValidation.sealImage == ''? 'is-info' : 'is-danger'"
                                    :message="fieldValidation.sealImage"
                                    style="padding-bottom: 10px;"
                            >
                            </b-field>
                        </div>

                    </div>
                </div>
                <div class="buttons">
                    <b-button type="is-primary" outlined rounded expanded @click="uploadSealImage" :loading="isSubmiting" >Register</b-button>
                </div>
            </template>
        </div>
    </div>
 </div>
</template>

<script>

    import UploadNICModal from '@/components/frontend/UploadNICModal'

export default {

    components:{
        UploadNICModal
    },
    
    data(){
        return{
            // use to store input field validation status
           fieldValidation:{
             sealImage:'',
           },
          isSubmiting:false,

          // variables to store field inputs
          sealImage : null, // to store the seal image, initially null
        }
    },

    methods:{ 
        closeModal:function(){
            this.$emit('close')
        },

        // method to validate the input fields
        validateFields:function (){
            var sealImage = true

            if(this.sealImage == null){
              console.log("Invalid seal image")
              this.fieldValidation.nicFrontImage = 'Seal image cannot be empty'
              sealImage = false
            }

            if(sealImage){
              return true
            }
            else{
              return false
            }
        },

        uploadSealImage : function(){
          this.isSubmiting = true
            //  temporary emit success event

          setTimeout(()=>{
            this.$emit('successUploadSealImage')
            console.log("Upload seal btn clicked")
            this.isSubmiting = false
          },3000)


        },


        resetInvalidFields : function(field){
             this.fieldValidation[field] =''
        },

        onSealCaptured: function (e) {
            this.sealImage = e
            this.$root.customerData.sealImage = e
            this.fieldValidation.sealImage = ''
        }
    }


}

</script>

<style scoped>
    #columnModalContent{
        margin: 10% auto;
        width: 537px;
        background: white;
        border-radius: 20px;
        min-height: 100px;
      

    }

    #heading > h1{
        color:#0D5DA3;
        font-size: 22pt;
        margin: 0;
        font-weight: bold;
    }

    .backdrop{
        top: 0;
        position: fixed;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.5);
        
    }


   #signInModalBodyTopic > p {
    font-size:12pt;
    color: black;
    margin-bottom: 20px;
   }

   #heading{
        -webkit-box-shadow: 0px 5px 8px -5px rgba(0,0,0,0.46); 
        box-shadow: 0px 5px 8px -5px rgba(0,0,0,0.46);
   }


    #body{
        margin:  20px;
        padding-left: 30px;
        padding-right: 30px;
        padding-bottom: 20px;
    }

    .sealImageArea{
      min-height: 200px;
      border: 1px solid #0D5DA3;
      text-align: center;
      align-items: center;
      padding-bottom: 10px;
    }

    #sealImage {
      margin: 10px auto;
      width: 140px;
      height: 140px;
      background-image: url("../../assets/images/camera-placeholder.jpg");
      background-size: contain;
    }
</style>

<!-- Globally accessible CSS -->
<style>
.required{
  color: red;
}
</style>